export type RegistryEntry = {
  promptName: string;
};

export const PROMPT_REGISTRY: Record<string, Record<string, RegistryEntry>> = {
  easyeom: {
    pdf: { promptName: 'Anchor_EasyEOM_pdf' },
  },
  intermodal: {
    pdf: { promptName: 'Anchor_Dynamic_Intermodal_pdf' },
    'xls/csv': { promptName: 'Anchor_Dynamic_Intermodal_Table' },
    json: { promptName: 'Anchor_Dynamic_Intermodal_json' },
    xml: { promptName: 'Anchor_Dynamic_Intermodal_xml' },
  },
  retail: {
    pdf: { promptName: 'Anchor_Dynamic_Retail_Pdf' },
    'xls/csv': { promptName: 'Anchor_Dynamic_Retail_table' },
    xml: { promptName: 'Anchor_Dynamic_Retail_xml' },
    json: { promptName: 'Anchor_Dynamic_Retail_json' },
  },
};

export function resolvePrompt(domain: string, fileType: string): RegistryEntry {
  const entry = PROMPT_REGISTRY[domain]?.[fileType];
  if (!entry) {
    throw new Error(
      `No prompt found for domain "${domain}" and fileType "${fileType}"`,
    );
  }
  return entry;
}
